import axios from "axios";

export default {
  methods: {
    async imageUpload(imagefile) {
      this.url = "";
      this.status = "";
      let formData = new FormData();
      formData.append("image", imagefile);
      formData.append("environment", this.environ);
      formData.append("origin", this.origin);
      formData.append("pretag", "images");
      let apilink =
        this.environ == "development"
          ? `${this.origin}/ImageHandler.php`
          : `${this.origin}/ImageHandler.php`;

      return await axios
        .post(apilink, formData, {
          header: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(response => {
          this.uploadingqimage = false;
          this.url = response.data.url;
          this.status = "success";
        })
        .catch(() => {
          this.status = "error";
          this.$bvModal
            .msgBoxOk(
              "Check your Network Connection. Could not upload Image.",
              {
                title: "No Network Connection",
                size: "xs",
                centered: true
              }
            )
            .then(() => {});
          //console.log(error);
        });
    }
  }
};
